// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"24165304","310":"24165304","420":"24165304","560":"24165304","680":"24165304","755":"24165304","974":"24165304"}[chunkId] + ".chunk.css";
};